import { ReactElement, useState } from 'react'
import Card from 'react-bootstrap/Card'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { CardWrapper, Loader } from '../../../../components'
import { Row, Container } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Small, Body } from '../../../../typography'
import getSubjectLogo from '../../../../helpers/getSubjectLogo'
import { colors } from '../../../../const/theme'
import formatDate from '../../../../helpers/formatDate'
import strings from '../../../../locale/en'
import {
  CardTitleContainer,
  FontAwesomeIconWrapper,
  CardText,
  SubjectImage,
  ColumnWrapper,
  DetailsContainer,
  JoinSessionButton,
  LightButton
} from './subcomponents'

const LiveSessions = (): ReactElement => {
  const { isLoading, sessions } = useSelector(
    (state: RootState) => ({
      isLoading: state.live?.isLoading,
      sessions: state.live?.liveSessions
    }),
    shallowEqual
  )
  const [session, setSession] = useState(sessions[0])
  const [sessionIdx, setSessionIdx] = useState(0)

  const {
    live: { joinSession, sessionLabel, date, startTime }
  } = strings

  const handlePagination = (newSessionIdx: number) => {
    setSession(sessions[newSessionIdx])
    setSessionIdx(newSessionIdx)
  }
  return (
    <CardWrapper>
      <Card.Body>
        {isLoading ? (
          <Loader />
        ) : (
          <Container>
            <Row>
              <ColumnWrapper sm={12} md={2}>
                <CardTitleContainer>
                  <SubjectImage
                    src={getSubjectLogo({
                      subject: session?.subjectName || ''
                    })}
                  />
                  {session && <CardText>{session.subjectName}</CardText>}
                </CardTitleContainer>
              </ColumnWrapper>
              <ColumnWrapper id="session-details" sm={12} md={4}>
                <Container>
                  <Row>
                    <ColumnWrapper sm={12} md={6}>
                      <FontAwesomeIconWrapper
                        icon={['fab', 'youtube']}
                        size="2x"
                      />
                      <DetailsContainer>
                        {session && <Body>{session.sessionName}</Body>}
                        <Small color={colors.gray}>{sessionLabel}</Small>
                      </DetailsContainer>
                    </ColumnWrapper>
                    <ColumnWrapper sm={12} md={6}>
                      <FontAwesomeIconWrapper
                        icon={['far', 'calendar-alt']}
                        size="2x"
                      />
                      <DetailsContainer>
                        {session && (
                          <Body>{formatDate(session.sessionDate)}</Body>
                        )}
                        <Small color={colors.gray}>{date}</Small>
                      </DetailsContainer>
                    </ColumnWrapper>
                  </Row>
                  <Row>
                    <ColumnWrapper sm={12} md={6}>
                      <FontAwesomeIconWrapper
                        icon={['far', 'clock']}
                        size="2x"
                      />
                      <DetailsContainer>
                        {session && <Body>{session.startTime}</Body>}
                        <Small color={colors.gray}>{startTime}</Small>
                      </DetailsContainer>
                    </ColumnWrapper>
                  </Row>
                </Container>
              </ColumnWrapper>
              <ColumnWrapper sm={12} md={3}>
                <JoinSessionButton
                  href={session?.url}
                  target={'_blank'}
                  variant="primary"
                  disabled={!session?.url}
                >
                  {joinSession}
                </JoinSessionButton>
              </ColumnWrapper>
              {sessions.length > 0 && (
                <ColumnWrapper id="button-group" sm={12} md={2}>
                  <LightButton
                    onClick={() => handlePagination(sessionIdx - 1)}
                    disabled={sessionIdx === 0}
                    variant="light"
                  >
                    <FontAwesomeIcon icon={['fas', 'chevron-left']} size="1x" />
                  </LightButton>
                  <LightButton
                    onClick={() => handlePagination(sessionIdx + 1)}
                    disabled={sessionIdx === sessions.length}
                    variant="light"
                  >
                    <FontAwesomeIcon
                      icon={['fas', 'chevron-right']}
                      size="1x"
                    />
                  </LightButton>
                </ColumnWrapper>
              )}
            </Row>
          </Container>
        )}
      </Card.Body>
    </CardWrapper>
  )
}

export default LiveSessions
